import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Shows from './pages/Shows';
import Songs from './pages/Songs';
function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/shows' element={<Shows/>}/>
        <Route path='/songs' element={<Songs/>}/>
        <Route path='/shop' element={<Shop/>}/>
        <Route path='/contact' element={<Contact/>}/>
        
      </Routes>
    </div>
  );
}

export default App;
